/**
 * CR V3 模块路由（Web 管理页）
 */

import { RouteRecordRaw } from 'vue-router'
import { Permission } from '@/utils/permission'

const crV3Routes: RouteRecordRaw[] = [
  {
    path: 'classroom-v3',
    name: 'ClassroomV3',
    redirect: '/classroom-v3/history',
    meta: {
      titleKey: 'menu.classroomV3',
      title: '智慧教室 V3',
      icon: 'FundProjectionScreenOutlined',
      orderNo: 51,
      permissions: [
        Permission.CLASSROOM_V3_USE,
        Permission.CLASSROOM_V3_VIEW,
        Permission.CLASSROOM_V3_MANAGE,
        Permission.CLASSROOM_V3_VERSION_MANAGE,
      ],
    },
    children: [
      {
        path: 'history',
        name: 'ClassroomV3History',
        component: () => import('@/modules/cr-v3/views/history/index.vue'),
        meta: {
          titleKey: 'menu.classroomV3History',
          title: '使用记录',
          icon: 'HistoryOutlined',
          keepAlive: true,
          permissions: [Permission.CLASSROOM_V3_VIEW],
        },
      },
      {
        path: 'version',
        name: 'ClassroomV3Version',
        component: () => import('@/modules/cr-v3/views/version/index.vue'),
        meta: {
          titleKey: 'menu.classroomV3Version',
          title: '版本配置',
          icon: 'CloudDownloadOutlined',
          keepAlive: true,
          permissions: [Permission.CLASSROOM_V3_VERSION_MANAGE],
        },
      },
      {
        path: 'runtime-config',
        name: 'ClassroomV3RuntimeConfig',
        component: () => import('@/modules/cr-v3/views/runtime-config/index.vue'),
        meta: {
          titleKey: 'menu.classroomV3RuntimeConfig',
          title: '基础配置',
          icon: 'SettingOutlined',
          keepAlive: true,
          permissions: [Permission.CLASSROOM_V3_MANAGE],
        },
      },
      {
        path: 'group-language',
        name: 'ClassroomV3GroupLanguage',
        component: () => import('@/modules/cr-v3/views/group-language/index.vue'),
        meta: {
          titleKey: 'menu.classroomV3GroupLanguage',
          title: '语种配置',
          icon: 'GlobalOutlined',
          keepAlive: true,
          permissions: [Permission.CLASSROOM_V3_MANAGE],
        },
      },
      {
        path: 'subtitle-display',
        name: 'ClassroomV3SubtitleDisplay',
        component: () => import('@/modules/cr-v3/views/subtitle-display/index.vue'),
        meta: {
          titleKey: 'menu.classroomV3SubtitleDisplay',
          title: '字幕样式',
          icon: 'FontColorsOutlined',
          keepAlive: true,
          permissions: [
            Permission.CLASSROOM_V3_USE,
            Permission.CLASSROOM_V3_VIEW,
            Permission.CLASSROOM_V3_MANAGE,
          ],
        },
      },
    ],
  },
]

export default crV3Routes
